import { CardContent } from '@mui/material';
import React, { useContext } from 'react';
import CartItemImageArteFinal from '../Cart/CartItem/CartItemImageArteFinal';
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import FavouriteSelected from './FavouriteSelected';
import { UserContext } from '../../context/UserProvider';

export const OneRowArte = ({ row, handleRowClick }) => {
  const { userRole } = useContext(UserContext);
  const [selectedIdsFavorite, setSelectedIdsFavorite] = useState([
    {
      idArte: row._id,
      centers: row.favourite.length > 0 ? row.favourite : [],
    },
  ]);

  const truncateName = (name, maxLength) => {
    if (name?.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  };

  // Definir el nombre truncado y si necesita un tooltip
  const truncatedName = truncateName(row.nameArteFinal, 85);
  const needsTooltip = row.nameArteFinal.length > 85;

  return (
    <div>
      <div
        className={
          'card-arte-final' +
          ((row?.formatos?.length === 0 && !row.isDescargable) ||
          row?.centerType?.length === 0 ||
          row?.allCategoriesDisabled === true ||
          (row.isDescargable &&
            !row.pdfLanguages?.castellano &&
            !row.pdfLanguages?.['País Vasco'] &&
            !row.pdfLanguages?.Cataluña &&
            !row.pdfLanguages?.Galicia)
            ? ' incomplete'
            : '') +
          (row.active ? '' : ' inactive')
        }
      >
        {userRole === 'MasterAdmin' && (
          <FavouriteSelected
            row={row}
            selectedIdsFavorite={selectedIdsFavorite}
            setSelectedIdsFavorite={setSelectedIdsFavorite}
          />
        )}

        <CartItemImageArteFinal
          onClick={() => handleRowClick(row)}
          styleContainer={{
            height: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          styleImg={{
            cursor: 'pointer',
            objectFit: 'contain',
            height: '90%',
            width: '90%',
          }}
          img={row.imglink}
        />

        <CardContent
          sx={{ padding: '0.5rem !important', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div style={{ textAlign: 'center', height: '80px' }}>
            <p
              className={`tooltip-artefinal-name-${row._id}`}
              style={{ marginBottom: '5px', fontWeight: 'bold' }}
              data-tip={needsTooltip ? row.nameArteFinal : ''}
            >
              {truncatedName.toUpperCase()}
            </p>
            <p style={{ fontStyle: 'italic' }}> {row.codeArteFinal} </p>
          </div>
        </CardContent>
      </div>

      {needsTooltip && (
        <Tooltip style={{ zIndex: 1000 }} anchorSelect={`.tooltip-artefinal-name-${row._id}`}>
          {row.nameArteFinal.toUpperCase()}
        </Tooltip>
      )}
    </div>
  );
};
